import { cn } from "../lib/utils";

const MAP = {
  pubblicata: { label: "Pubblicata", cls: "bg-[#F3ECDC] text-[#87713F] border-[#C6AD76]" },
  assegnato: { label: "Assegnato", cls: "bg-[#DCE3EC] text-[#18314F] border-[#8FA3BE]" },
  completata: { label: "Completata", cls: "bg-[#DCFCE7] text-[#15803D] border-[#BBF7D0]" },
  da_fatturare: { label: "Fatturare", cls: "bg-[#942F30] text-white border-[#7A2627] font-bold" },
  annullata: { label: "Annullata", cls: "bg-[#F3DCDC] text-[#942F30] border-[#D48E8E]" },
};

export const StatusBadge = ({ status }) => {
  const s = MAP[status] || { label: status, cls: "bg-slate-100 text-slate-600 border-slate-200" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold",
        s.cls
      )}
    >
      {s.label}
    </span>
  );
};

const MODE_MAP = {
  fcfs: "First Come First Served",
  manual: "Selezione Manuale",
  direct: "Assegnazione Diretta",
};

export const ModeBadge = ({ mode }) => (
  <span className="inline-flex items-center rounded-full border border-slate-200 bg-slate-50 px-2.5 py-0.5 text-xs font-medium text-slate-600">
    {MODE_MAP[mode] || mode}
  </span>
);
